import React, { useState } from 'react';
import { Button, Image, Modal, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import type { UploadProps } from 'antd/es/upload';
import type { RcFile, UploadFile } from 'antd/es/upload/interface';

interface IProps {
  fileType: string;
  onUploadSuccess: (file: string) => void;
}

const getBase64 = async (file: RcFile): Promise<string> =>
  // eslint-disable-next-line @typescript-eslint/return-await
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const BuyerPicUpload: React.FC<IProps> = ({ fileType, onUploadSuccess }) => {
  const [file, setFile] = useState<UploadFile>();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  const handleCancel = (): void => setPreviewOpen(false);

  const handlePreview = (file: UploadFile): void => {
    if (!file.url && !file.preview) {
      void (async () => {
        file.preview = await getBase64(file.originFileObj as RcFile);
      })();
    }

    setPreviewImage(file.url ?? (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(file.name ?? '');
  };

  const uploadUrl = process.env.REACT_APP_AUTOSTREAM_API
    ? `${process.env.REACT_APP_AUTOSTREAM_API}/files/buyer/img`
    : '';

  const props: UploadProps = {
    name: 'file',
    action: uploadUrl,
    headers: {
      authorization: `Bearer ${localStorage.getItem('accessToken') ?? ''}`,
    },
    listType: 'picture-card',
  };

  const handleChange = (info: any, onUploadSuccess: (file: string) => void): void => {
    if (info.file.status === 'done') {
      setFile(info.file);

      if (info.fileList.length > 0) {
        const filePath = info.fileList.map((file: any) => file.response.filePath)[0];
        onUploadSuccess(filePath);
      } else {
        onUploadSuccess('');
      }
    }
  };

  return (
    <>
      <Upload
        {...props}
        onChange={(info) => handleChange(info, onUploadSuccess)}
        onPreview={handlePreview}
      >
        <Button icon={<UploadOutlined />}></Button>
      </Upload>
      <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
        <Image width={'100%'} src={previewImage} preview={false} />
      </Modal>
    </>
  );
};

export default BuyerPicUpload;
